import { useEffect, useState } from "react";
import { userService } from "../../services/userService";
import { personName } from "./taskUtils";

/** Names for a handful of staff ids (cached by userService) — for alerts
 * shown outside the Tasks page. */
export function useStaffNames(ids: (string | null | undefined)[]): Map<string, string> {
    const [names, setNames] = useState<Map<string, string>>(new Map());
    const key = Array.from(new Set(ids.filter(Boolean) as string[])).sort().join(",");

    useEffect(() => {
        if (!key) return;
        let cancelled = false;
        Promise.all(key.split(",").map((id) => userService.getUserBasic(id))).then((users) => {
            if (cancelled) return;
            setNames((prev) => {
                const next = new Map(prev);
                users.forEach((u) => u && next.set(u.user_id, personName({ display_name: u.display_name ?? null, email: u.email })));
                return next;
            });
        });
        return () => {
            cancelled = true;
        };
    }, [key]);

    return names;
}
